import React from 'react';
import { Linkedin, Mail } from 'lucide-react';
import { mockData } from '../data/mock';

const Footer = () => {
  const { personalInfo, contact } = mockData;
  
  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <footer className="bg-gray-900/50 border-t border-gray-800">
      <div className="container">
        <div className="py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="md:col-span-2">
              <button 
                onClick={() => scrollToSection('#home')}
                className="text-2xl font-bold text-gradient mb-4 text-left"
              >
                Stefan Hay
              </button>
              <p className="text-gray-400 mb-6 max-w-md">
                Freelancer für Digitale Kommunikation, Social Media & Employer Branding. 
                Strategische Kommunikation für Unternehmen jeder Größe.
              </p>
              <div className="flex space-x-4">
                <a
                  href={personalInfo.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <Linkedin size={24} />
                </a>
                <a
                  href={`mailto:${contact.email}`}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  <Mail size={24} />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Navigation</h3>
              <ul className="space-y-2">
                <li>
                  <button 
                    onClick={() => scrollToSection('#home')}
                    className="text-gray-400 hover:text-white transition-colors text-left"
                  >
                    Home
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('#about')}
                    className="text-gray-400 hover:text-white transition-colors text-left"
                  >
                    Über mich
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('#services')}
                    className="text-gray-400 hover:text-white transition-colors text-left"
                  >
                    Services
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('#contact')}
                    className="text-gray-400 hover:text-white transition-colors text-left"
                  >
                    Kontakt
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
              <ul className="space-y-2 text-gray-400">
                <li>{contact.email}</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm">
                © 2024 Stefan Hay. Alle Rechte vorbehalten.
              </p>
              <div className="flex space-x-6 mt-4 md:mt-0">
                <a href="/datenschutz" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Datenschutz
                </a>
                <a href="/impressum" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Impressum
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;